import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import axios from "axios";
import { FaStar } from "react-icons/fa";
import { getReview } from "../../api/Reviews/reviewApi";
const ReviewList = ({ reviewType, productId }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const params = {};
        if (reviewType) params.reviewType = reviewType;
        if (productId) params.productId = productId;

        const response = await getReview(params);
        setReviews(response.data);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };
    fetchReviews();
  }, [reviewType, productId]);

  return (
    <>
      <Row>
        {reviews.map((review, index) => (
          <Col key={index} md={12} className="mb-1">
            <div className="d-flex align-items-center">
              <img
                src={`https://i.pravatar.cc/40?img=${index + 1}`} // Placeholder image
                alt={review.userId}
                className="rounded-circle mr-3"
                style={{ width: "40px", height: "40px" }}
              />
              <div style={{ marginLeft: "10px" }}>
                <span style={{ fontSize: "1rem", fontWeight: "bold" }}>
                  {review.userId}
                </span>
                <div className="d-flex align-items-center">
                  <span className="mr-2">
                    {[...Array(5)].map((_, i) => (
                      <FaStar
                        key={i}
                        size={14}
                        color={
                          i < Math.round(review.rating) ? "#ffc107" : "#e4e5e9"
                        }
                      />
                    ))}
                  </span>
                </div>
              </div>
            </div>
            <p
              style={{ fontSize: "0.8rem", fontWeight: "normal" }}
              className="text-muted mt-2"
            >
              {review.review || "No review text available."}
            </p>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ReviewList;
